import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { useLocation } from "react-router-dom";
import { CryptoPaymentRequest, paymentAPI } from "../services/payment";
import { Bitcoin, Shield, CheckCircle } from "lucide-react";
import PageWithNavbar from "./PageWithNavbar";

export const CryptoCheckout = () => {
    const [isProcessing, setIsProcessing] = useState(false);
    const location = useLocation();
    // Optionally, you can accept a selectedPlan from location.state
    const selectedPlan = location.state?.selectedPlan || null;
    
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const handleCryptoCheckout = async () => {
        setIsProcessing(true);
        try {
            console.log("Processing Crypto payment for plan:", selectedPlan);
            const paymentRequest: CryptoPaymentRequest = { plan: selectedPlan.id, cryptoType: 'bitcoin', anonymous: true };
            const data = await paymentAPI.processCryptoPayment(paymentRequest);
            console.log("Crypto payment response:", data);
            if (data.sessionId) {
            console.log("Crypto payment session id:", data.sessionId);
            }
            if (data.url) {
            // Redirect to invoice URL
            window.location.href = data.url;
            } else {
            alert("No invoice URL returned. Please try again or contact support."); 
            }
        } catch (err) {
            console.error("Crypto checkout error:", err);
            alert("Crypto checkout error. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <PageWithNavbar>
        <div className="bg-background flex flex-col items-center justify-center py-12 px-4">
            <Card className="max-w-lg w-full">
            <CardHeader>
                {/* Selected Plan Display */}
                {selectedPlan && (
                <Card className="mb-6 bg-primary/5 border-primary/20">
                    <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                        <div>
                        <h3 className="font-semibold flex items-center">
                            <CheckCircle className="h-4 w-4 text-primary mr-2" />
                            Selected Plan: {selectedPlan.title}
                        </h3>
                        <p className="text-sm text-muted-foreground">
                            {selectedPlan.title === "Free" ? "Free forever" : `$${selectedPlan.price} (1 year license)`}
                        </p>
                        </div>
                        <Badge variant={selectedPlan.title === "Premium" ? "default" : "secondary"}>
                        {selectedPlan.title}
                        </Badge>
                    </div>
                    </CardContent>
                </Card>
                )}
            <div className="flex items-center gap-2 mb-2">
                <Bitcoin className="h-6 w-6 text-yellow-500" />
                <Shield className="h-5 w-5 text-muted-foreground" />
                <CardTitle>Anonymous Crypto Checkout</CardTitle>
            </div>
            <CardDescription>
            Pay with Bitcoin or Monero (XMR) and get instant, anonymous access. We'll autogenerate a username and password for you—no registration required.
            </CardDescription>
            </CardHeader>
            <CardContent>
                <p className="text-muted-foreground text-sm mb-2">
                    Choose your plan and pay securely with cryptocurrency. After payment, your credentials will be shown below.
                </p>
                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 p-3 rounded-lg mb-4">
                    <p className="text-sm text-blue-700 dark:text-blue-300">
                        <strong>📅 License Terms:</strong> Your purchase includes one year of updates and support. You may continue using your current version indefinitely after this period.
                    </p>
                </div>
                <div className="flex items-center mb-4 mt-4">
                    <input
                        type="checkbox"
                        id="acceptTerms"
                        checked={acceptedTerms}
                        onChange={e => setAcceptedTerms(e.target.checked)}
                        className="mr-2 h-4 w-4"
                    />
                    <label htmlFor="acceptTerms" className="text-sm">
                        I accept the <a href="/terms" target="_blank" className="underline text-primary">Terms of Service</a>, <a href="/privacy" target="_blank" className="underline text-primary">Privacy Policy</a>, and <a href="/eula.txt" target="_blank" className="underline text-primary">EULA</a>
                    </label>
                </div>
                <Button
                    className="w-full mt-2"
                    disabled={!acceptedTerms || isProcessing}
                    onClick={handleCryptoCheckout}
                >
                    {isProcessing ? "Redirecting to BTCPayServer..." : "Go to Checkout (BTCPayServer)"}
                </Button>
            </CardContent>
            </Card>
        </div>
        </PageWithNavbar>
        );
    };

export default CryptoCheckout;
